exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".smart-site {\n  text-align: center;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.smart-site>section {\n  flex: auto;\n  overflow: hidden;\n}\n", ""]);
